import { render, staticRenderFns } from "./inputCenter.vue?vue&type=template&id=445dca56&scoped=true&"
import script from "./inputCenter.vue?vue&type=script&lang=js&"
export * from "./inputCenter.vue?vue&type=script&lang=js&"
import style0 from "./inputCenter.vue?vue&type=style&index=0&id=445dca56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445dca56",
  null
  
)

export default component.exports